import PropTypes from 'prop-types';
import {ReactComponent as Close} from '~/assets/icons/close.svg';

export function ContentModal({
  children,
  classNames,
  isVisible,
  toggleVisibility,
}) {
  return (
    <div className={'modal ' + classNames}>
      {isVisible && (
        <>
          <div className="modal__overlay" />
          <div className="modal__wrapper">
            <div className="modal__dialog" role="dialog">
              <button
                type="button"
                className="modal__close-button"
                onClick={toggleVisibility}
              >
                <Close />
              </button>
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

ContentModal.propTypes = {
  children: PropTypes.any.isRequired,
  classNames: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  toggleVisibility: PropTypes.func.isRequired,
};
